import React from 'react';
import { PageMasthead } from './page-masthead';

export function LegalPage({ title, lead, updated, sections }) {
  return (
    <div className="flex flex-col min-h-screen">
      <PageMasthead title={title} lead={lead} />

      <div className="mx-auto max-w-[760px] w-full gutter pb-16 sm:pb-24">
        {updated && (
          <p className="text-sm text-muted-foreground">Last updated {updated}</p>
        )}

        <div className="mt-8 space-y-10">
          {sections.map((section) => (
            <section key={section.heading}>
              <h2 className="text-xl sm:text-2xl font-bold tracking-tight display">
                {section.heading}
              </h2>
              <div className="mt-3 space-y-4 text-[15px] leading-relaxed text-foreground/80">
                {section.body.map((item, i) =>
                  Array.isArray(item) ? (
                    <ul key={i} className="list-disc space-y-2 pl-5">
                      {item.map((point, j) => (
                        <li key={j}>{point}</li>
                      ))}
                    </ul>
                  ) : (
                    <p key={i}>{item}</p>
                  )
                )}
              </div>
            </section>
          ))}
        </div>
      </div>
    </div>
  );
}

export default LegalPage;
